export enum DeliveryStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  FAILED = 'failed',
  SENT = 'sent',
  DELIVERED = 'delivered',
  READ = 'read',
}

export enum MessageType {
  TEMPLATE = 'template',
  CUSTOMER_SUPPORT = 'customer_support',
}

export enum MessageDirection {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

interface BaseChatMessage {
  id: string;
  direction: MessageDirection;
  messageType: MessageType;
  providerMessageId: string;
  content: string;
  deliveryStatus: DeliveryStatus;
  createdAt: string;
  updatedAt: string;
  meta?: {
    failureReason?: string;
    extra?: {
      // attachment url
      mediaUrl?: string;
      // tracking url of the button (if button exists), original url can be found in trackableLink
      buttonUrl?: string;
    };
  }
}

export interface ChatMessage extends BaseChatMessage {
  trackableLink?: {
    id: number;
    slug: string;
    originalUrl: string;
  }
  template?: {
    id: number;
    slug: string;
    meta?: {
      buttons?: {
        quickReplies?: string[];
      };
    };
  }
}

export interface RecentChatMessage extends BaseChatMessage {
  leadName: string;
  leadUuid: string;
  customerSupportWindowEnabled: boolean;
}
